<template>
  <div class="pf-skeleton-container">
    <div class="pf-skeleton-container-header">
      <Skeleton height="20px" width="150px" borderRadius="4px" />
      <Skeleton height="18px" width="216px" borderRadius="4px" />
    </div>

    <div class="pf-skeleton-container-main">
      <div v-for="row in 4" :key="row" class="pf-skeleton-container-main-row">
        <Skeleton
          v-for="col in 2"
          :key="col"
          width="481px"
          height="40px"
          borderRadius="4px"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@/components/Skeleton/Skeleton';
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.pf-skeleton-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid $colorD20;
  background: $colorN00;

  &-header,
  &-main {
    align-self: stretch;
  }

  &-header {
    display: flex;
    padding: 24px 24px 16px 24px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5px solid $colorD20;
  }

  &-main {
    display: flex;
    padding: 16px 24px 24px 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    &-row {
      display: flex;
      align-items: flex-start;
      gap: 24px;
      align-self: stretch;
    }
  }
}
</style>
